import { render, staticRenderFns } from "./Syarat.vue?vue&type=template&id=3be54316&scoped=true"
import script from "./Syarat.vue?vue&type=script&lang=js"
export * from "./Syarat.vue?vue&type=script&lang=js"
import style0 from "./Syarat.vue?vue&type=style&index=0&id=3be54316&prod&lang=css"
import style1 from "./Syarat.vue?vue&type=style&index=1&id=3be54316&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be54316",
  null
  
)

export default component.exports